/// <amd-module name="VSS/Redux/Modules" />
import * as React from "react";
import { DynamicModuleLoader, IModule } from "redux-dynamic-modules";
import { IObjectProperty, IObservableObject, ObservableObject } from "VSS/Core/Observable";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { VssComponent } from "VSS/Platform/Layout";

export const Modules: IObservableObject<IModule<unknown>> = new ObservableObject<IModule<unknown>>();

export interface IRegisteredModuleProps {
    contributionId: string;

    reduxModuleId: string;
}

export interface IRegisteredModuleState {
    module: IModule<unknown> | undefined;
}

export class WrappedModule extends VssComponent<IRegisteredModuleProps, IRegisteredModuleState> {
    constructor(props: IRegisteredModuleProps, context: any) {
        super(props, context);

        const { reduxModuleId } = props;
        this.state = {
            module: Modules.get(reduxModuleId)
        };
    }

    public render(): JSX.Element | null {
        const { module } = this.state;

        if (module) {
            return <DynamicModuleLoader modules={[module]} children={null} />;
        }

        return null;
    }

    public componentDidMount() {
        const { contributionId, reduxModuleId } = this.props;
        const { module } = this.state;

        if (!module) {
            // Module not yet loaded, subscribe for changes
            const observer = (update: IObjectProperty<IModule<unknown>>) => {
                if (update.key === reduxModuleId) {
                    // Module is now available
                    Modules.unsubscribe(observer);

                    this.setState({
                        module: update.value
                    });
                }
            };
            Modules.subscribe(observer);

            // Load module that will hopefully bring in the wanted module
            const svc = this.context.pageContext.getService<IVssContributionService>("IVssContributionService");
            svc.getContributionAsync(contributionId).catch(reason => {
                // To do something?
            });
        }
    }
}
